import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Noty from 'noty';
import piction from '../../utils/piction';
import UMODetailViewBody from './UMODetailViewBody';
import Loader from '../ui/Loader';
import { WorkspaceTag } from '../../utils/searchUtils';
import { SESSION_EXPIRED_MESSAGE } from '../../constants/sessionStateTypes';
import { sessionExpired } from '../../actions/session';
import appConfig from '../../appConfig';
import { addError } from '../../actions/messageDialog';
import { toggleFullImageView } from '../../actions/mainUI';

const mapStateToProps = state => ({
  umoGallery: state.umoGallery,
});

const mapDispatchToProps = dispatch => ({
  sessionExpired: err => dispatch(sessionExpired(err)),
  addError: err => dispatch(addError(err)),
  toggleFullImageViewDispatch:
    (isShown, umoData) => dispatch(toggleFullImageView(isShown, umoData)),
});

class UMODetailView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      primaryID: null,
      umo: null,
      alternates: null,
      hasChanged: false,
      isWorkspace: false,
      workspaceID: null,
      isError: false,
    };

    this.requestPromise = null;
    this.onFullImageToggle = this.onFullImageToggle.bind(this);
    this.onAltClick = this.onAltClick.bind(this);
    this.onPrimarySelect = this.onPrimarySelect.bind(this);
    this.handleError = this.handleError.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const callData = appConfig.alternateReps ?
    { zoomify: 'true',
      CHECK_ALTERNATE_REPS: 'TRUE',
      ALTERNATE_COLLECTION: appConfig.alternateReps[1],
      ALTERNATE_METATAG: appConfig.alternateReps[0],
      ALTERNATE_EXCLUDE_RELATIONAL: appConfig.alternateExcRelational } :
    { zoomify: 'true',
      ENABLE_ALTERNATE: 'true' };
    this.requestPromise = piction.getUMOs(`UMO_ID:"${this.props.umoID}"`, callData)
      .then((res) => {
        if (res.umoList.all[0]) {
          const umo = res.umoList.all[0];
          if (umo.data.re && umo.data.re[0] > 1) {
            this.requestPromise = piction.getUMOs(`REPRESENTATIVES:${this.props.umoID}`, callData)
              .then((res) => {
                this.setState({
                  umo,
                  primaryID: this.props.umoID,
                  alternates: res.umoList,
                  isLoading: false,
                  isError: false,
                });

                return true;
              })
              .catch((err) => {
                this.handleError(err);
              });
          } else {
            this.setState({ umo, primaryID: this.props.umoID, isLoading: false, isError: false });
          }
        } else {
          this.handleError(this.props.intl.formatMessage({ id: 'umoDetailView.requestUMOError' }));
        }
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          this.props.sessionExpired(err);
          this.closeModal();
        } else {
          this.handleError(err);
        }
      });
    // derive the type of result set it is -- at the moment, mainly used to derive if
    // is workspace
    const tagList = this.props.umoGallery.getIn(['searchParams', 'tagList']);
    if (tagList && tagList.length === 1) {
      const tag = tagList[0];
      if (tag instanceof WorkspaceTag) {
        this.setState({
          isWorkspace: true,
          workspaceID: tag.value,
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.requestPromise) {
      this.requestPromise.cancel();
    }
  }

  onPrimarySelect(umo) {
    const n = new Noty({
      theme: 'bootstrap-v4',
      type: 'info',
      text: this.props.intl.formatMessage({ id: 'umoDetailView.setAsPrimaryWarningMessage' }),
      layout: 'center',
      buttons: [
        Noty.button('Change', 'btn btn-primary', () => {
          const callArgs = {
            PTR_ID: umo,
            UMO_ID: this.state.primaryID,
          };
          this.setState({ isLoading: true, hasChanged: true });
          this.requestPromise = piction.request('set_master', callArgs).then((res) => {
            this.setState({ primaryID: umo, isLoading: false });
          })
          .catch((err) => {
            if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
              this.props.sessionExpired(err);
            }
            this.setState({ isLoading: false, hasChanged: false });
          });
          n.close();
        }, { id: 'button1', 'data-status': 'ok' }),

        Noty.button('Cancel', 'btn btn-error', () => {
          n.close();
        }),
      ],
    });
    n.show();
  }

  onFullImageToggle() {
    const umo = this.state.umo;
    let zoomifyURL = umo.data.z[0];
    // Gross hardcoding of 3D template. Revert after demo.
    if (umo.id === '7092422') {
      zoomifyURL += '&override_template=SYSTEM.TIFF3D&override_suffix=3D';
    }
    const umoData = {
      fullSrc: umo.type === 'PHOTO' ? umo.webQuality.url : umo.originalList.all[0]._data.$.h,
      type: umo.type,
      zoomifyURL,
    };
    this.props.toggleFullImageViewDispatch(true, umoData);
  }

  onAltClick(e) {
    const newUmo = this.state.alternates.all.find(obj => obj.id === e.target.id);
    this.setState({ umo: newUmo, isLoading: false });
  }

  componentDidCatch(error, info) {
    this.handleError(error, info);
  }

  handleError(error, info) {
    console.log('error: ', error);
    console.log('info: ', info);
    this.setState({ isLoading: false, isError: true });
    this.closeModal();
    this.props.addError(this.props.intl.formatMessage({ id: 'general.error' }));
  }


  closeModal() {
    if (this.state.hasChanged) this.props.dispatch(this.props.retrieveUMOs());
    this.props.toggleUMODetailView(false);
  }

  render() {
    return (
      this.state.isError ? null :
      <div className="umo-detail-view">
        {this.state.isLoading ? <Loader className="umo-detail-view__loader" /> :
        <UMODetailViewBody
          umo={this.state.umo}
          alternates={this.state.alternates}
          onAltClick={this.onAltClick}
          primaryID={this.state.primaryID}
          onPrimarySelect={this.onPrimarySelect}
          onFullImageToggle={this.onFullImageToggle}
          toggleUMODetailView={this.closeModal}
          selectedWorkspaceData={this.props.selectedWorkspaceData}
          dispatch={this.props.dispatch}
          isWorkspace={this.state.isWorkspace}
          workspaceID={this.state.workspaceID}
        />
          }
      </div>
    );
  }
}

UMODetailView.propTypes = {
  umoID: PropTypes.string,
  toggleUMODetailView: PropTypes.func.isRequired,
  toggleFullImageViewDispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
  dispatch: PropTypes.func,
  sessionExpired: PropTypes.func,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  umoGallery: PropTypes.instanceOf(Map),
  addError: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UMODetailView));



// WEBPACK FOOTER //
// ./src/js/components/UMODetailView/index.jsx